module.exports = __webpack_public_path__ + "static/media/Artboard10.6115d07b.jpg";